import {Box} from '@mui/material';

const Em = ({children}) => {
  return <Box component="em" sx={{fontWeight: 900, color: 'primary.main'}}>
    {children}
  </Box>
}

export default Em;
